var map = {
	"./gameUpdatesService.js": 4403,
	"./gameUpdatesUtility.js": 158,
	"./layoutLibraryI18nService.js": 5978,
	"./notificationStreamService.js": 9822,
	"./notificationStreamUtility.js": 167
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3545;